export const LANGUAGES = [
  {
    id: 28,
    name: "Czech",
    englishName: "Czech",
    isoCode: "CZE",
    active: true
  },
  {
    id: 5,
    name: "Danish",
    englishName: "Danish",
    isoCode: "DAN",
    active: true
  },
  {
    id: 8,
    name: "Dutch",
    englishName: "Dutch",
    isoCode: "NLD",
    active: true
  },
  {
    id: 1,
    name: "English",
    englishName: "English",
    isoCode: "ENG",
    active: true
  },
  {
    id: 26,
    name: "Estonian",
    englishName: "Estonian",
    isoCode: "EST",
    active: true
  },
  {
    id: 10,
    name: "Finnish",
    englishName: "Finnish",
    isoCode: "FIN",
    active: true
  },
  {
    id: 7,
    name: "French",
    englishName: "French",
    isoCode: "FRA",
    active: true
  },
  {
    id: 2,
    name: "Deutsch",
    englishName: "German",
    isoCode: "DEU",
    active: true
  },
  {
    id: 17,
    name: "German",
    englishName: "German",
    isoCode: "CHE",
    active: true
  },
  {
    id: 24,
    name: "Greek",
    englishName: "Greek",
    isoCode: "GRC",
    active: true
  },
  {
    id: 14,
    name: "Hungarian",
    englishName: "Hungarian",
    isoCode: "HUN",
    active: true
  },
  {
    id: 22,
    name: "Indonesian",
    englishName: "Indonesian",
    isoCode: "IDN",
    active: true
  },
  {
    id: 15,
    name: "Italian",
    englishName: "Italian",
    isoCode: "ITA",
    active: true
  },
  {
    id: 3,
    name: "日本語",
    englishName: "Japanese",
    isoCode: "JPN",
    active: true
  },
  {
    id: 27,
    name: "Latvian",
    englishName: "Latvian",
    isoCode: "LAV",
    active: true
  },
  {
    id: 25,
    name: "Lithuanian",
    englishName: "Lithuanian",
    isoCode: "LTU",
    active: true
  },
  {
    id: 23,
    name: "Malaysian",
    englishName: "Malaysian",
    isoCode: "MYS",
    active: true
  },
  {
    id: 9,
    name: "Norwegian",
    englishName: "Norwegian",
    isoCode: "NOR",
    active: true
  },
  {
    id: 16,
    name: "Polish",
    englishName: "Polish",
    isoCode: "POL",
    active: true
  },
  {
    id: 12,
    name: "Portuguese",
    englishName: "Portuguese",
    isoCode: "PRT",
    active: true
  },
  {
    id: 21,
    name: "Romanian",
    englishName: "Romanian",
    isoCode: "ROU",
    active: true
  },
  {
    id: 20,
    name: "Russian",
    englishName: "Russian",
    isoCode: "RUS",
    active: true
  },
  {
    id: 4,
    name: "Española",
    englishName: "Spanish",
    isoCode: "SPA",
    active: true
  },
  {
    id: 11,
    name: "Swedish",
    englishName: "Swedish",
    isoCode: "SWE",
    active: true
  },
  {
    id: 18,
    name: "Thai",
    englishName: "Thai",
    isoCode: "THA",
    active: true
  },
  {
    id: 19,
    name: "Turkish",
    englishName: "Turkish",
    isoCode: "TUR",
    active: true
  },
  {
    id: 6,
    name: "Tiếng Việt",
    englishName: "Vietnamese",
    isoCode: "VIE",
    active: true
  },
  {
    id: 30,
    name: "Bulgarian",
    englishName: "Bulgarian",
    isoCode: "BGR",
    active: true
  },
  {
    id: 32,
    name: "Albania",
    englishName: "Albania",
    isoCode: "ALB",
    active: true
  },
  {
    id: 29,
    name: "Ukrainian",
    englishName: "Ukrainian",
    isoCode: "UKR",
    active: true
  },
  {
    id: 33,
    name: "Cрпски језик",
    englishName: "Serbian",
    isoCode: "SRP",
    active: true
  },
  {
    id: 34,
    name: "Slovenščina",
    englishName: "Slovenian",
    isoCode: "SVN",
    active: true
  },
  {
    id: 35,
    name: "Croatian",
    englishName: "Croatian",
    isoCode: "HRV",
    active: true
  },
  {
    id:31,
    name:"Azerbaijani",
    englishName:"Azerbaijani",
    isoCode:"AZE",
    active:true
  },
  {
    id:36,
    name:"Slovak",
    englishName:"Slovak",
    isoCode:"CZE",
    active:true
  },
  {
    id:37,
    name:"Arabic",
    englishName:"Arabic",
    isoCode:"ARA",
    active:true
  }
];
